const styles = theme => ({})

export default styles



// WEBPACK FOOTER //
// ./src/components/MaskedCodeInput/styles.js